import {css} from 'lit';
export const styles = css`@keyframes spin {
  from {
    transform: rotate(-45deg);
  }

  to {
    transform: rotate(315deg);
  }
}

:host {
  display: inline-flex;
  align-items: flex-start;
}

:host::before {
  position: relative;
}

:host([badgeCount]) {
  position: relative;
  font-size: 22px;
}

:host([name='calendar-day'])::before,
:host([name='calendar-alt'])::before {
  top: -1px;
}

:host([name='send'])::before,
:host([name='comment-alt-lines'])::before {
  top: 1px;
}

:host([name='thumbtack'])::before,
:host([name='thumbtack-s'])::before {
  top: 2px;
}

:host([name='exclamation-triangle'])::before {
  display: inline-block;
  transform: scale(0.9);
}

:host([name='spinner-third'])::before {
  display: inline-block;
  animation: spin 1.5s cubic-bezier(0.5, 0.2, 0.3, 0.5) infinite;
}
`;
export default styles;
